export enum PostHogEvent {
  // Tag
  tagAdd = 'Tag Add',
  tagDelete = 'Tag Delete',
  tagUpdate = 'Tag Update',

  // Board
  boardUpdate = 'Board Update',

  // Position
  positionAdd = 'Position Add',
  positionUpdate = 'Position Update',
  positionDelete = 'Position Delete',

  positionAddGetStarted = 'Position Add from Get Started Page',

  // Product
  productAdd = 'Product Add',
  productUpdate = 'Product Update',
  productDelete = 'Product Delete',

  // Leads
  leadsAdd = 'Leads Add',
  leadsUpdate = 'Leads Update',
  leadsDelete = 'Leads Delete',

  // Objection
  objectionAdd = 'Objection Add',
  objectionDelete = 'Objection Delete',
  objectionUpdate = 'Objection Update',

  // Methodology
  methodologyAdd = 'Methodology Add',
  methodologyDelete = 'Methodology Delete',

  methodologyAddGetStarted = 'Methodology Add from Get Started Page',

  // Resume
  resumeAdd = 'Resume Add',
  resumeDelete = 'Resume Delete',
  resumeUpdate = 'Resume Update',

  resumeAddGetStarted = 'Resume Add from Get Started Page',

  // Personality
  personalityAdd = 'Personality Add',
  personalityDelete = 'Personality Delete',
  personalityUpdate = 'Personality Update',

  // Company
  companyAdd = 'Company Add',
  companyDelete = 'Company Delete',
  companyUpdate = 'Company Update',

  // Session Template
  sessionTemplateAdd = 'Session Template Add',
  sessionTemplateDelete = 'Session Template Delete',
  sessionTemplateUpdate = 'Session Template Update',

  // Session
  sessionAddGetStarted = 'Session Add from Get Started Page',
  sessionContinue = 'Session Continue',

  sessionUpdateAiFeedback = 'Session Update AI Feedback',
  sessionUpdate = 'Session Update',
  sessionAdd = 'Session Add',
  sessionDelete = 'Session Delete',
  sessionLaunch = 'Session Launch',
  sessionFreeTrialLaunch = 'Session Free Trial Launch',
  sessionManuallyEnd = 'Session Manually End',

  sessionNoStartTime = 'Session No Start Time',
  sessionFreeTrialExpired = 'Session Free Trial Expired',
  sessionPingError = 'Session Ping Error',
  sessionException = 'Session Exception',
  sessionPingException = 'Session Ping Exception',
  sessionPausedByHuman = 'Session Paused by Human',
  sessionDeepgramError = 'Session Deepgram Error',
  sessionDeepgramClosed = 'Session Deepgram Closed',
  sessionMicError = 'Session Mic Error',
  sessionMicClosed = 'Session Mic Closed',
}
